/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { WEEKDAYS } from "../common/Const";
import { getClassTypeName } from "../common/Helpers";

const FilterBar = ({
  filters,
  setFilters,
  uniqueClassTypes,
  expandedRowsToggle,
  expandAllRows,
  setSelectedRows,
  filteredAttendance,
  lessonTypes
}) => (
  <div className="row mx-0 d-flex align-items-center report-filters mb-3">
    <div className="col-sm-auto report-expand p-0">
      <div className="expand-button text-with-icon d-flex justify-content-end">
        <button
          className="p-0 shadow-none btn btn-transparent expand-button report-checkbox-large"
          onClick={() => expandAllRows()}
          type="button"
        >
          <i
            className={`fas ${expandedRowsToggle ? "fa-plus" : "fa-minus"}`}
            style={{ color: "black" }}
          />
        </button>
        <input
          className="report-checkbox-large mr-2"
          type="checkbox"
          onChange={(e) => {
            const isChecked = e.target.checked;
            const updatedSelection = filteredAttendance.reduce(
              (acc, reg) => {
                acc[reg.id] = reg.students.reduce(
                  (studentAcc, student) => ({
                    ...studentAcc,
                    [student.id]: isChecked,
                  }),
                  {}
                );
                return {
                  ...acc,
                  [reg.id]: acc[reg.id],
                };
              },
              {}
            );

            setSelectedRows(updatedSelection);
          }}
        />
      </div>
    </div>
    <div className="col-sm report-date-col p-0">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Data"
        value={filters.date}
        onChange={e => setFilters({ ...filters, date: e.target.value })}
      />
    </div>
    <div className="col-sm report-weekday-col">
      <select
        className="form-control w-100"
        value={filters.dayOfWeek}
        onChange={e => setFilters({ ...filters, dayOfWeek: e.target.value })}
      >
        <option value="">Dzień tyg.</option>
        {WEEKDAYS.map(weekday => (
          <option key={weekday.id} value={weekday.name}>
            {weekday.name}
          </option>
        ))}
      </select>
    </div>
    <div className="col-sm report-start-time-col">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Godzina"
        value={filters.startTime}
        onChange={e => setFilters({ ...filters, startTime: e.target.value })}
      />
    </div>
    <div className="col-sm report-lesson-type-col">
      <select
        className="form-control w-100"
        value={filters.classType}
        onChange={e => setFilters({ ...filters, classType: e.target.value })}
      >
        <option value="">Typ lekcji</option>
        {uniqueClassTypes.map(classTypeId => (
          <option key={classTypeId} value={classTypeId}>
            {getClassTypeName(classTypeId, lessonTypes)}
          </option>
        ))}
      </select>
    </div>

    <div className="col-sm report-student-col">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Uczeń"
        value={filters.studentName}
        onChange={e => setFilters({ ...filters, studentName: e.target.value })}
      />
    </div>
    <div className="col-sm report-client-col">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Klient"
        value={filters.clientName}
        onChange={e => setFilters({ ...filters, clientName: e.target.value })}
      />
    </div>
    <div className="col-sm report-teacher-col">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Nauczyciel"
        value={filters.teacherName}
        onChange={e => setFilters({ ...filters, teacherName: e.target.value })}
      />
    </div>
    <div className="col-sm report-present-col pl-0">
      <input
        className="form-control w-100"
        type="checkbox"
        checked={filters.isPresent}
        onChange={e => setFilters({ ...filters, isPresent: e.target.checked })}
      />
    </div>
    <div className="col-sm report-comment-col pl-0">
      <input
        type="text"
        className="form-control w-100"
        placeholder="Uwagi"
        value={filters.comment}
        onChange={e => setFilters({ ...filters, comment: e.target.value })}
      />
    </div>
  </div>
);

FilterBar.propTypes = {
  filters: PropTypes.shape({
    date: PropTypes.string,
    dayOfWeek: PropTypes.string,
    startTime: PropTypes.string,
    classType: PropTypes.string,
    studentName: PropTypes.string,
    clientName: PropTypes.string,
    teacherName: PropTypes.string,
    isPresent: PropTypes.bool,
    comment: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  uniqueClassTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  expandedRowsToggle: PropTypes.bool.isRequired,
  expandAllRows: PropTypes.func.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  filteredAttendance: PropTypes.array.isRequired,
  lessonTypes: PropTypes.shape({
    id: PropTypes.string,
    types: PropTypes.array,
  }).isRequired,
};

export default FilterBar;
